import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TenantMasterPackageApi } from '../api/tenantMasterPackage.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantMasterPackageData,TenantMasterPackage } from '../../../interfaces/masters/tenantMasterPackage';

@Injectable()
export class TenantMasterPackageService extends TenantMasterPackageData {

  constructor(private api: TenantMasterPackageApi) {
    super();
  }


  list(): Observable<TenantMasterPackage[]> {
    return this.api.list();
  }


 
  getById(url: string): Observable<TenantMasterPackage>{
      return this.api.getById(url);
  }

  create(url: string, data: any): Observable<TenantMasterPackage> {
    return this.api.add(url,data);
  }
   createArray(url: string, data:any): Observable<any> {
     debugger;
      return this.api.addArray(url,data);
    }

  update(url: string, data: any): Observable<TenantMasterPackage> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
